/* eslint-disable max-len */

import type { ApiLangPack } from '../api/types';

export const fallbackZhHansLangPackInitial = {
  HideInProtectedGroup: '本群禁止私聊',
  PrivateChatDaMei: '禁止私聊',
  ProtectedHiddenParticipants: '群成员已隐藏，无法开启禁止私聊',
  ErrorUnauthorized: '无权限执行此操作',
  'startChat': '开始聊天',
  'sendComment': '发送添加好友请求',
  'sendRemarkName': '设置备注',
  'userinfo': '用户信息',
  'deleteApplication': '删除申请', 
  'waiting': '等待验证',
  'accepted': '已通过',
  'rejected': '已拒绝',
  'reject': '拒绝',
  'agree': '同意', 
  'NewApplication': '申请',
  'placeholders.ContactList': '没有符合搜索条件的联系人。',
  'placeholders.ContactListEmpty': '联系人列表为空。',
  ApplicationList: '申请列表',
  'placeholders.ApplicationList': '没有符合搜索条件的申请。',
  'placeholders.ApplicationListEmpty': '申请列表为空。',
  MenuAddAccount: '添加账号',
  PremiumLimitAccountsTitle: '达到上限',
  PremiumLimitAccountsNoPremium: '已达到当前可连接账号数量上限。订阅 68IM 高级版后可再添加一个账号。',
  PremiumLimitAccountsPremium: '已达到当前可连接账号数量上限。',
  'Contacts.Username.NotRegistred': '用户名不存在',
  WrongNumber: '手机号码有误？',
  SentAppCode: `我们已向您另一台设备上的**68IM**应用发送了验证码。`,
  'Login.JustSentSms': '我们已经向您的手机发送了一条包含验证码的短信。请在上方输入您的验证码。',
  'Login.JustSentEmail': '我们已经向您的邮箱发送了一封包含验证码的邮件。请在上方输入您的验证码。',
  'Login.PasswordResetSentSms': '我们已向您的手机号发送验证码，请在下方输入验证码。',
  'Login.PasswordResetSentEmail': '我们已向您的邮箱发送验证码，请在下方输入验证码。',
  'Login.Header.Password': '输入密码',
  'Login.EnterPasswordDescription': '您已启用了两步验证，因此您的帐号已受到额外密码的保护。',
  CheckPasswordPlaceholder: '密码',
  Next: '下一步',
  Continue: '继续',
  StartText: '请确认您的国际电话区号并输入您的手机号码。',
  'Login.PhonePlaceholder': '您的手机号码',
  'Login.Next': '下一步',
  'Login.QR.Login': '扫描二维码登录',
  'Login.QR.Title': `扫码登录68IM`,
  'Login.QR.Help1': `在您的手机上打开68IM`,
  'Login.QR.Help2': '进入**设置** > **设备** > **链接桌面设备**',
  'Login.QR2.Help2': '进入**设置** → **设备** → **链接桌面设备**',
  'Login.QR.Help3': '点击手机屏幕确认登录',
  'Login.QR.Cancel': '手机号登录',
  'Login.QR.EmailLogin': '邮箱登录',
  YourName: '您的姓名',
  'Login.Register.Desc': '在此处输入您的名字，并上传头像。',
  'Login.Register.FirstName.Placeholder': '名',
  'Login.Register.LastName.Placeholder': '姓氏',
  'Login.Register.Invite.Placeholder': '邀请码',
  Required: '必填',
  UnRequired: '选填',
  'Login.SelectCountry.Title': '国家/地区',
  lng_country_none: '此国际电话区号不存在',
  LoginPass: '登录密码',
  LoginPassTip: '密码必须是8-16位，可以全英文，不能全数字',
  LoginPassInput: '请输入登录密码',
  LoginInputOldPass: '请输入旧登录密码',
  LoginOldPassError: '旧登录密码错误',
  LoginPassPhone: '手机号验证',
  LoginPassEmail: '邮箱验证',
  LoginPassNotSet: '未设置',
  LoginPassAlreadySet: '已设置',
  LoginPassNoIdentifier: '当前账号没有可用于验证的手机号或邮箱',
  LoginSetPass: '设置登录密码',
  LoginSetNewPass: '设置新登录密码',
  LoginForgotPassword: '忘记密码？',
  LoginAccountPassTip: '为了您的账号安全，请设置登录密码',
  PleaseEnterNewFirstPasswordHint: '请输入新密码',
  PleaseEnterNewSecondPasswordHint: '请再次输入密码',
  PleaseEnterPassword: '请输入新密码',
  PHONE_NUMBER_INVALID: '无效的手机号码',
  PHONE_CODE_INVALID: '验证码无效',
  PASSWORD_HASH_INVALID: '密码错误',
  USER_PASSWORD_INVALID: '密码错误',
  USER_PASSWORD_ERROR: '密码错误',
  USER_PASSWORD_INVALI: '密码无效',
  PHONE_PASSWORD_FLOOD: '出于账号安全限制，当前设备暂时不能修改登录密码，请稍后再试。',
  PHONE_NUMBER_BANNED: '该手机号码已被禁止使用。',
  BAD_REQUEST: '注册失败，请检查昵称或邀请码后重试',
  INVITE_CODE_REQUIRED: '请填写邀请码',
  INVITE_CODE_INVALID: '邀请码无效',
  FIRSTNAME_INVALID: '昵称无效',
  PHONE_CODE_EXPIRED: '验证码已过期，请重新获取',
  VALIDATE: '人机验证未通过，请重试',
  SENDCODE_OVERRUN: '操作过于频繁，请稍后再试',
  SEND_CODE_UNAVAILABLE: '验证码发送失败，请稍后再试',
  SMS_ERROR_TO_EMAIL: '短信发送失败，请改用邮箱登录',
  MERCHANT_BANNED: '该服务已被停用',
  MERCHANT_DELETED: '该服务已下线',
  ALREADY_REGISTERED: '该号码已注册',
  DELETE_USER_TO_SHORT: '该号码注销的账号需满 30 天才能重新注册',
  USER_DEACTIVATED: '该账号已被停用',
  IP_BANNED: '当前 IP 已被封禁',
  DEVICE_BANNED: '设备已被封禁',
  AuthRequestFailed: '请求失败，请稍后重试',
  'Unexpected Error': '出现未知错误，请稍后重试',
} as ApiLangPack;
